import { Middleware, Navigation, PrefixStrategy } from '@inlang/paraglide-next'

import * as t from './paraglide/messages.js'
import type { AvailableLanguageTag } from './paraglide/runtime'

// strategy
export const strategy = PrefixStrategy<AvailableLanguageTag>({ prefixDefault: 'never' })

// middleware
export const middleware = Middleware({ strategy })
export const { Link, useRouter, usePathname, redirect, permanentRedirect } = Navigation({
  strategy,
})

// translations
export { t }
export { languageTag } from './paraglide/runtime'

// add to config:
// export default paraglide({
//   paraglide: {
//     project: "./src/core/lib/locale/project.inlang",
//     outdir: "./src/core/lib/locale/paraglide"
//   },
//   ...nextConfig
// });
